import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { LibraryMusicOutlined } from "@mui/icons-material";

/** Cover art for music showcase tiles when there is no album image URL. */
export default function ShowcaseMusicArt({ title, accent, compact }) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: compact ? 0.5 : 1,
        background: `linear-gradient(135deg, ${alpha(accent, 0.45)} 0%, ${alpha(accent, 0.12)} 55%, ${alpha("#1a1a2e", 0.85)} 100%)`,
      }}
    >
      <LibraryMusicOutlined
        sx={{
          fontSize: compact ? 40 : 56,
          color: alpha("#fff", 0.92),
          filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.35))",
        }}
      />
      {title && (
        <Typography
          variant={compact ? "caption" : "body2"}
          fontWeight={700}
          sx={{
            px: 1.5,
            textAlign: "center",
            color: alpha("#fff", 0.9),
            textShadow: "0 1px 4px rgba(0,0,0,0.4)",
          }}
          noWrap={compact}
        >
          {title}
        </Typography>
      )}
    </Box>
  );
}
